import React from 'react';

export default class DashboardIcon extends React.Component {
  render() {
    return (
      <svg
        height="100%"
        viewBox="0 0 20.002 17"
        enableBackground="new 0 0 20.002 17"
      >
        <g>
          <g>
            <rect x="2.995" fill="#BD311F" width="14" height="2" />
          </g>
          <path
            fill="#BD311F"
            d="M19.877,6.475C19.877,6.02,20.124,5,19.925,5h0.047l-2.063-2H2.228L0.062,5h0.034
            c-0.199,0-0.026,1.02-0.026,1.475c0,1.109,0.925,2.284,1.925,2.697v7.003C1.995,16.631,1.772,17,2.228,17h15.681
            c0.456,0,0.086-0.369,0.086-0.825V9.109C18.995,8.67,19.877,7.537,19.877,6.475z M3.995,15V9.32c1-0.2,1.141-0.835,1.458-1.676
            c0.384,1.019,1.125,1.748,2.279,1.748c1.154,0,2.013-0.729,2.397-1.748c0.384,1.019,1.302,1.748,2.455,1.748
            c1.154,0,1.556-0.729,1.94-1.748c0.331,0.877,0.471,1.536,1.471,1.704V15H3.995z"
          />
        </g>
        <rect
          x="3.995"
          y="6"
          className="fill-none stroke"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          width="12"
          height="9"
        />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/icons/MerchantsIcon.js